/* eslint-disable */

(function addingAsterisk() {
  const requiredLabels = document.querySelectorAll(
    '.js-form-type-checkbox label.js-form-required, .js-form-type-radio label.js-form-required',
  );
  if (!requiredLabels.length > 0) return;
  requiredLabels.forEach((item) => {
    const asterisk = document.createElement('span');
    asterisk.innerText = '*';
    asterisk.classList.add('asterisk');
    item.appendChild(asterisk);
  });
})();

(function (Drupal, $) {
  Drupal.behaviors.niceSelect = {
    attach(context) {
      'use strict';

      $('select').niceSelect();

      $(document).ajaxComplete(() => {
        $('select').niceSelect();
      });
    },
  };
})(Drupal, jQuery);
